import classNames from 'classnames';

export const getButtonClassName = ({ isDisabled }) =>
  classNames(
    'disabled:bg-transparent',
    'disabled:text-gray-400',
    'disabled:border-gray-400',
    'disabled:shadow-none',
    'hover:bg-blue-300',
    'hover:shadow-lg',
    'bg-blue-200',
    'text-white',
    'font-bold',
    'py-2',
    'px-12',
    'ml-3',
    'border',
    'border-blue-200',
    'rounded',
    'text-base',
    {
      'cursor-not-allowed': isDisabled,
    },
  );
